/* eslint-disable */
const mutations = {
  setLoyalty(state, loyalty) {
    state.data = loyalty;
  },
};

export default mutations;
